import { render, staticRenderFns } from "./orderForm.vue?vue&type=template&id=09f53186&"
import script from "./orderForm.vue?vue&type=script&lang=ts&"
export * from "./orderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports